exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@400;500;700&display=swap);", ""]);

// module
exports.push([module.id, ".cart .clear-cart{font-size:.8em}.cart .option-name{font-size:.8em;margin-bottom:-7px!important}.cart .option-name.observation{line-height:normal}.cart .option-name span{width:21px}.cart .row-product:last-of-type{margin-bottom:20px!important}.cart .v-list-item{min-height:25px;padding:0}.font-small{font-size:11px!important}", ""]);

// exports
